<script lang="ts">
  import a11yClick from '../../utils/a11y-click';

  export let id: string;
  export let value: string;
  export let group: Array<string> | undefined = undefined;
  export let checked = false;
  export let required = false;
  export let disabled = false;

  let inputElement: HTMLInputElement;

  $: group && updateCheckbox(group, value);
  $: group && updateGroup(checked, value);

  $: uniqueId = `checkbox-input-${id}-${value}`;

  function updateCheckbox(group: Array<string>, value: string) {
    checked = group.includes(value);
  }

  function updateGroup(checked: boolean, value: string) {
    const filteredGroup = (group || []).filter(v => v !== value);
    group = checked ? [...filteredGroup, value] : filteredGroup;
  }
</script>

<style lang="postcss">
  .checkbox {
    display: flex;
    align-items: center;
    flex-shrink: 0;
    outline: none;
  }

  .checkbox:focus-visible input[type='checkbox'] {
    box-shadow: var(--ubilabs-focus-box-shadow);
  }

  .checkbox input[type='checkbox'] {
    vertical-align: text-bottom;
  }

  .checkbox input[type='checkbox'] + .labelText {
    margin-top: -0.05em; /* optically vertically center the text */
  }

  .checkbox input[type='checkbox']:checked:not(:disabled) + .labelText {
    color: var(--ubilabs-checkbox-checked-label-color);
  }
</style>

<label class="checkbox {$$props.class}" for={uniqueId}>
  <input
    id={uniqueId}
    type="checkbox"
    on:click
    bind:checked
    {value}
    {required}
    {disabled}
    bind:this={inputElement}
    on:keypress={event => {
      if (a11yClick(event) && inputElement) {
        inputElement.click();
      }
    }} />

  <span class="labelText">
    <slot />
  </span>
</label>
